module.exports = __webpack_public_path__ + "img/cash-payment.73397a17.png";